import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { closePopup, popupContentSelector } from "../../app/popup-slice"
import styles from "./info-legend-dialog.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { useMessages2 } from "../../hooks/useLanguage"
import { ButtonBar } from "../buttons"

import ButtonAddon from '../../img/legend-icons/ButtonAddon.png';
import ButtonAddonRequired from '../../img/legend-icons/ButtonAddonRequired.png';
import ButtonEdit from '../../img/legend-icons/ButtonEdit.png';
import ButtonErase from '../../img/legend-icons/ButtonErase.png';
import ButtonRotate from '../../img/legend-icons/ButtonRotate.png';
import Slider from '../../img/legend-icons/Slider.png';
import TopView2D from '../../img/legend-icons/TopView2D.png'
import tutorialSelection from '../../img/legend-icons/tutorial_selection_A.png'
import zoomMinMax from '../../img/legend-icons/zoominmax.png'
import reset from '../../img/legend-icons/reset.png'
import information from '../../img/legend-icons/information_icon.png'

const ITEM_LIST = [
    { id:1, textKey: "Legende_schuifbalk", image: Slider },
    { id:2, textKey: "Legende_zoom", image: zoomMinMax }, 
    { id:3, textKey: "Legende_start_position", image: reset },
    { id:4, textKey: "Legende_info", image: information },
    { id:5, textKey: "Legende_2D", image: TopView2D }, 
    { id:6, textKey: "Legende_select", image: tutorialSelection, isBig:true },
    { id:7, textKey: "Legende_turn", image: ButtonRotate },
    { id:8, textKey: "Legende_add", image: ButtonAddon, omitInBasket3D: true }, 
    { id:9, textKey: "Legende_verplicht", image: ButtonAddonRequired, omitInBasket3D: true },
    { id:10, textKey: "legende_edit", image: ButtonEdit, omitInBasket3D: true },
    { id:11, textKey: "Legende_kader", image: ButtonErase, omitInBasket3D: true },
];

export const InfoLegendDialog = () => {

    const dispatch = useAppDispatch()
    const [isTechnicalInfo, setIsTechnicalInfo] = useState(true)
    const popupContent = useAppSelector(popupContentSelector);
    const { messages } = useMessages2();

    const onHandleStepButton = () => {
        setIsTechnicalInfo(!isTechnicalInfo)
    }

    const handleClose = () => {
        dispatch(closePopup())
    }

    const itemList = (popupContent ?? {}).legendType === 'basket3d' ?
        ITEM_LIST.filter(i => !i.omitInBasket3D)
        : 
        ITEM_LIST;

    return (
        <div className={styles.dialogContainer}>
        
            <div className={styles.topContent}>
                <div className={styles.title}>
                    <h2>{messages?.intro_info_title}</h2>
                </div>
                
                <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.closeButton}
                    onClick={handleClose}
                />
            </div>
                
                <div className={styles.infoContainer} >
                    <ul className={styles.textInfo}>
                        {itemList.map((item) => {
                            let size = item?.isBig ? styles.big : styles.standard

                            return(
                                <li key={`legend-${item.id}`}>
                                    <div className={styles.imageContainer}>
                                        <img className={size} src={item.image}/>
                                    </div>
                                    <span>{(item?.textKey && messages) ? messages[item.textKey] : ''}</span>
                                </li>
                            )
                        }
                    )}

                    </ul>
                    <div className={styles.directButton} onClick={onHandleStepButton}>             
                        <ButtonBar>
                            <button onClick={handleClose} className={styles.button}>{messages?.page_close_button}</button>
                        </ButtonBar>
                    </div>
                </div> 

        </div>
    )
}
